import { useEffect, useState } from 'react'

/**
 * Keeps showing the last non-empty `items` while a search is in flight, so a
 * list does not blank for a few frames on every keystroke. Held items are
 * dropped when `scope` changes.
 */
export function useHeldWhileSearching<T>(
  items: T[],
  isSearching: boolean,
  scope: string | undefined
): T[] {
  const [held, setHeld] = useState({ scope, items })
  useEffect(() => {
    if (items.length > 0 || held.scope !== scope) {
      setHeld({ scope, items })
    }
  }, [held.scope, items, scope])
  if (items.length > 0) return items
  return isSearching && held.scope === scope ? held.items : items
}
